import { render, staticRenderFns } from "./CellRendererMultipleChoiceExercises.vue?vue&type=template&id=015dd38f"
import script from "./CellRendererMultipleChoiceExercises.vue?vue&type=script&lang=js"
export * from "./CellRendererMultipleChoiceExercises.vue?vue&type=script&lang=js"
import style0 from "./CellRendererMultipleChoiceExercises.vue?vue&type=style&index=0&id=015dd38f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports